module.exports = __webpack_public_path__ + "static/img/tui.840a4d83.png";